import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PopupDialogComponent } from '@ppl/ui';
import { NzFormDirective } from 'ng-zorro-antd/form';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';

/**
 * Confirmation dialog with required Notes, used by the correction actions (Revert, NAV Reset, Reprocess).
 * Emits the trimmed notes; the parent closes it once its API call completes.
 */
@Component({
  selector: 'ppl-correction-notes-dialog',
  standalone: true,
  imports: [PopupDialogComponent, NgZorroModule, NzFormDirective, ReactiveFormsModule],
  templateUrl: './correction-notes-dialog.component.html',
  styleUrl: './correction-notes-dialog.component.css'
})
export class CorrectionNotesDialogComponent implements OnChanges {
  readonly NOTES_MAX_LENGTH = 1000;

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() title = '';
  @Input() okText = '';
  @Input() message = '';
  @Input() placeholder = '';
  @Output() confirmed = new EventEmitter<string>();

  form: FormGroup;

  constructor(fb: FormBuilder) {
    this.form = fb.group({
      notes: [null, [Validators.required, Validators.pattern(/\S/), Validators.maxLength(this.NOTES_MAX_LENGTH)]],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue) {
      this.form.reset();
    }
  }

  onConfirm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.confirmed.emit(this.form.value.notes.trim());
  }

  onVisibleChange(visible: boolean) {
    this.visible = visible;
    this.visibleChange.emit(visible);
  }
}
